import { createSlice } from "@reduxjs/toolkit"

export const searchBarShownSlice = createSlice({
  name: "searchBarShown",
  initialState: false,
  reducers: {
    setSearchBarShown: (_state, action) => {
      return action.payload
    },
  },
})

export const { setSearchBarShown } = searchBarShownSlice.actions

export default searchBarShownSlice.reducer
